import { useEffect, useRef, useState } from "react";
import { datePost, getCookie, getImageForWidgetNews, getVideoLoopUrl } from "../helpers";
import { useClippingForPreview } from "./useClippingForPreview";
import { useRouter } from "next/router";

const useNewsDataModules = (props = {}, clippingsRequired = { desktop: [], mobile: []}) => {  
  const router = useRouter();
  const dynamicType = props?.__extra?.dynamicType ?? "default";
  const [loading, setLoading] = useState(['abTestModule', 'dynamicNewsModule'].includes(dynamicType) && !props?.isPreview);
  /* if(props?.__extra?.isListType) {
    props.images = props.images?.[0]?.clippings || [];
  } */
  const handleStateName = (news, clippingsRequired) => {

    const payWallExclusive = news?.metadata?.payWallAccessControl === "suscribers-only";

    const imageWeb = getImageForWidgetNews({
      clippingsRequired,
      images: news?.__extra?.isListType? news.images?.[0]?.clippings : news?.images,
      selectedImageId: news?.selectedImageId,
      customClippings: news?.customClippings,
      croppedImages: news?.croppedImages,
      imageOriginUrl: news?.imageOriginUrl
    })  
    if(news?.epigraphe && imageWeb) {
      imageWeb.epigraphe = news.epigraphe
    }    

    let urlTarget = news?.urlTarget ? news?.urlTarget : '_self';
    const date = datePost(news?.publishedDate);

    let videoLoop = "";
    let videoLoopFlavors = [];
    if(news.videosOpenLoop?.enabled){
      videoLoop = getVideoLoopUrl(news.videosOpenLoop,news.video);
      videoLoopFlavors = news.videosOpenLoop?.flavors;
    }

    let urlSelected = news?.url;
    
    const DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL || "https://www.clarin.com";
    urlSelected = urlSelected?.replace(DOMAIN_URL+"/clarin80", "https://www.clarin80.com");
    if(urlSelected?.includes("https://www.clarin80.com")) {
      urlTarget = "_blank";
    }

    if(news?.urlAlternative?.trim()) {
      urlSelected = news.urlAlternative;
    }

    const displayTitle = news?.type === "videos2" ? news?.name : news?.title;

    return {
      ...news,
      url: urlSelected,
      date,
      imageWeb,
      payWallExclusive,
      urlTarget,
      videoLoop,
      displayTitle,
      videoLoopFlavors
    }
  }

  const [newsData, setNewsData] = useState(handleStateName(props, clippingsRequired));

  const { imagePreview } = useClippingForPreview(
    clippingsRequired,
    props?.__extra?.isListType? props.images?.[0]?.clippings : props?.images,
    props?.customClippings,
    props?.selectedImageId,
    props?.croppedImages
  );

  const containerName = props?.__extra?.containerName ?? "";

  const formatUrlDynamic = (params, url) => {
    if (router.query.app === "true" || getCookie("app") === "true") {
      return;
    }
    if(newsData?.url?.includes(params)) return;
    return url + params;
  }

  useEffect(() => {
    if (props.isPreview) return;
    let news = JSON.parse(localStorage.getItem('news_reads')) || [];
    const existingNewsIndex = news.findIndex(item => item.id === props.lilaNewsID);
    let newsReaded = false;
    if (existingNewsIndex !== -1) {
      newsReaded = true;
      const oldModificated = new Date(news[existingNewsIndex].modifiedDate);
      const currentModificated = new Date(props?.modificatedAt || new Date(0))
      oldModificated.setMilliseconds(0);
      currentModificated.setMilliseconds(0);
      if (oldModificated < currentModificated){
        newsReaded = false;
        news = news.filter((item) => item.id !== props.lilaNewsID);    
        localStorage.setItem('news_reads', JSON.stringify(news));
      }
    }
    if(dynamicType === "default") return;
    const isRandomDynamicNews = getCookie("randomDynamicNews");
    if (isRandomDynamicNews === "0" && dynamicType === "abTestModule") {
      const newUrl = formatUrlDynamic("?fijo", newsData.url);
      if(newUrl) {        
        setNewsData((prev) => ({
          ...prev,
          url: newUrl 
        }))
      }
      setLoading(false);
      return
    };  
    if(dynamicType === "dynamicNewsModule" || (dynamicType === "abTestModule" && isRandomDynamicNews === "1")) {
      if(newsReaded && props?.relatedLilaNews?.length > 0) {
        let nextNewsIndex = -1;
        for (let i = 0; i < props.relatedLilaNews.length; i++) {
          const relatedNewsIndex = news.findIndex(item => item.id === props.relatedLilaNews[i].id);
          if (relatedNewsIndex === -1) {
            nextNewsIndex = i;
            break;
          }
        }
        if(nextNewsIndex === -1) {
          const newUrl = formatUrlDynamic("?dinamico", newsData.url);
          if(newUrl) {        
            setNewsData((prev) => ({
              ...prev,
              url: newUrl 
            }))
          }
          setLoading(false);
          return;
        }
        setNewsData(() => {
          const news = props.relatedLilaNews[nextNewsIndex];          
          const imageWeb = getImageForWidgetNews({
            clippingsRequired,
            images: news?.__extra?.isListType? news.images?.[0]?.clippings : news?.images,
          });
          const newUrl = formatUrlDynamic("?dinamico_rotacion", news.url);

          return {
            ...news,
            url: newUrl,
            imageWeb
          }
        });
      } else {
        const newUrl = formatUrlDynamic("?dinamico", newsData.url);
        if(newUrl) {        
          setNewsData((prev) => ({
            ...prev,
            url: newUrl 
          }))
        }
      }
      setLoading(false);
    }
  }, [])

  const prevPropsRef = useRef(null);
  useEffect(() => {
    const previousProps = prevPropsRef.current;
    const propKeys = Object.keys(props);
    if (
      previousProps &&
      propKeys.length === Object.keys(previousProps).length &&
      propKeys.every((key) => Object.is(props[key], previousProps[key]))
    ) return;
    prevPropsRef.current = props;

    if (!props.isPreview && props?.fromRecipeCollection) {
      setNewsData(handleStateName(props, clippingsRequired));
      return;
    }
    if (!props.isPreview) return;
    setNewsData(handleStateName(props, clippingsRequired));
  }, [props]);

  return {
    ...newsData,
    loading,
    asPath: router.asPath,
    containerName,
    imagePreview,
  };
}

export default useNewsDataModules;